import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { triggerToast } from '../../utils/toast';
import { blogApiUrl } from '../../utils/variables';

const NewsletterUnsubscribe = () => {
    const navigate = useNavigate();
    const [processed, setProcessed] = useState(false);

    useEffect(() => {
        const handleUnsubscribe = async () => {
            const urlParams = new URLSearchParams(window.location.search);
            const token = urlParams.get('token');
            
            if (!token) {
                triggerToast('Invalid unsubscribe link', 'error');
                setTimeout(() => navigate('/'), 2000);
                return;
            }

            try {
                const response = await axios.get(`${blogApiUrl}/newsletter/unsubscribe?token=${token}`);
                
                if (response.status === 200) {
                    triggerToast(response.data.message || 'Successfully unsubscribed from newsletter!', 'success');
                }
            } catch (err) {
                const errorMessage = err.response?.data?.error || err.response?.data?.message || 'Failed to unsubscribe. Please try again or contact support.';
                triggerToast(errorMessage, 'error');
            } finally {
                setProcessed(true);
                setTimeout(() => navigate('/'), 3000);
            }
        };

        if (!processed) {
            handleUnsubscribe();
        }
    }, [navigate, processed]);

    return (
        <div style={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'linear-gradient(135deg, #1C1D26 0%, #2A2B3D 100%)',
            color: '#fff',
            fontFamily: 'Rubik, sans-serif'
        }}>
            <div style={{ textAlign: 'center' }}>
                <div style={{
                    width: '40px',
                    height: '40px',
                    border: '3px solid rgba(246, 37, 90, 0.3)',
                    borderTop: '3px solid #F6255A',
                    borderRadius: '50%',
                    animation: 'spin 1s linear infinite',
                    margin: '0 auto 20px'
                }}></div>
                <h2 style={{ fontSize: '24px', fontWeight: '600', marginBottom: '10px' }}>
                    Processing...
                </h2>
                <p style={{ color: 'rgba(255, 255, 255, 0.6)', fontSize: '16px' }}>
                    You will be redirected automatically
                </p>
            </div>
            <style>{`
                @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }
            `}</style>
        </div>
    );
};

export default NewsletterUnsubscribe;
